/*
 * Seed entries for the Event Configuration "Languages" tab (event_i18n).
 *
 * These are example UI-wording keys shown when the i18n table is still empty,
 * so the editor opens with a starting set instead of a blank table. They are
 * illustrative: a legacy page (or the webapp) opts in to a key by calling the
 * translation helper for it — e.g. in PHP `echo t('nav_home');` (lc_i18n.inc.php),
 * which returns the stored value for the active language, or the fallback.
 *
 * Add/rename/remove rows freely in the GUI; only non-empty values are stored.
 */
export const I18N_DEFAULTS: { [lang: string]: { [key: string]: string } } = {
  de: {
    nav_home: 'Start',
    nav_program: 'Programm',
    nav_agenda: 'Mein Terminplan',
    nav_logout: 'Abmelden',
    btn_save: 'Speichern',
    btn_cancel: 'Abbrechen',
    label_welcome: 'Willkommen',
    msg_login_required: 'Bitte melden Sie sich an, um fortzufahren.',
  },
  en: {
    nav_home: 'Home',
    nav_program: 'Programme',
    nav_agenda: 'My agenda',
    nav_logout: 'Log out',
    btn_save: 'Save',
    btn_cancel: 'Cancel',
    label_welcome: 'Welcome',
    msg_login_required: 'Please log in to continue.',
  },
  fr: {
    nav_home: 'Accueil',
    nav_program: 'Programme',
    nav_agenda: 'Mon agenda',
    nav_logout: 'Déconnexion',
    btn_save: 'Enregistrer',
    btn_cancel: 'Annuler',
    label_welcome: 'Bienvenue',
    msg_login_required: 'Veuillez vous connecter pour continuer.',
  },
};
